import {Pipe, PipeTransform} from '@angular/core'
import {AuthenticatedUser} from '../../../auth/auth-status.service'

@Pipe({
  name: 'bgoUserPerspective',
  standalone: true,
})
export class PerspectivePipe implements PipeTransform {
  transform(authenticatedUser?: AuthenticatedUser): {admin: boolean; pro: boolean; agent: boolean; client: boolean} {
    const prioritzed = this.prioritizePerspective(authenticatedUser)
    return {
      admin: prioritzed.includes('admin'),
      pro: prioritzed.includes('pro'),
      agent: prioritzed.includes('agent'),
      client: prioritzed.includes('client'),
    }
  }

  private prioritizePerspective(authenticatedUser?: AuthenticatedUser) {
    const facets: ('admin' | 'pro' | 'agent' | 'client')[] = []
    if (authenticatedUser?.isGlobalAdministrator) facets.push('admin')
    if (authenticatedUser?.pro) facets.push('pro')
    if (authenticatedUser?.agent) facets.push('agent')
    if (authenticatedUser?.client) facets.push('client')

    // when admin, we also all facets
    if (authenticatedUser?.isGlobalAdministrator) return facets
    // otherwise, only show the first facet
    return [facets.shift()]
  }
}
